<template>
  <div class="stock-container">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <van-search v-model="filterForm.categoryName" placeholder="搜索饰品名称" style="flex: 1" />
      <van-button size="small" type="primary" @click="search">搜索</van-button>
      <!-- <div
        @click="doStock()"
        class="recycle-button"
      :style="{ backgroundImage: 'url(' + require('@/assets/shou.jpg') + ')' }"
      style="width: 70px;height: 80px;background-size: contain"
    >
    </div> -->

      <div class="recycle-button" @click="doStock()">
        <img :src="require('@/assets/shou.jpg')" style="
            height: 60px;
            width: 60px;
            object-fit: contain;
            object-position: center;
          " />
        <div style="
            text-align: center;
            color: #000;
            font-weight: bold;
            font-size: 14px;
          ">
          点击出售
        </div>
      </div>

      <!-- <van-button size="small" type="primary" @click="doStock()" style="margin-left: 5px;">上架</van-button> -->
      <div class="search-icon" @click="showSidebarPopup = true">
        <van-icon name="filter-o" size="22" />
      </div>
    </div>
    <!-- 侧边栏弹窗 -->
    <van-popup v-model:show="showSidebarPopup" position="right" :style="{ width: '70%', height: '100%' }" round>
      <div class="sidebar-form">
        <!-- 品质筛选 -->
        <van-field v-model="filterForm.quality" readonly name="picker" label="品质" placeholder="请选择品质"
          @click="showPicker = true" :clearable="true" />

        <van-field v-model="filterForm.description" readonly name="picker" label="赛季" placeholder="请选择赛季"
          @click="showSaiji = true" :clearable="true" />

        <van-field v-model="filterForm.template" clearable label="模板" placeholder="请输入模板" />

        <van-field v-model="filterForm.isStackLable" label="ST" placeholder="是否ST" readonly is-link
          @click="showCategoryTypesPicker = true" />

        <div>
          <van-button size="small" style="width: 100%; margin-bottom: 10px" type="primary"
            @click="reset">重置</van-button>
          <van-button size="small" style="width: 100%" type="primary" @click="search">搜索</van-button>
        </div>
      </div>
    </van-popup>
    <!--    我要上架 弹出框-->
    <div>
      <van-popup v-model:show="showTop" position="center" :style="{ height: '80%' }" round>
        <!-- 表单内容 -->
        <div class="form-container">
          <!-- 饰品基本信息 -->
          <div class="info-section">
            <van-cell-group>
              <!-- 饰品类型选择 - 使用树形结构 -->
              <van-field v-model="weaponForm.categoryName" label="上架饰品" placeholder="请选择饰品类型" readonly is-link
                @click="showTreeSelect" required />

              <van-field label="饰品展示">
                <template #input>
                  <div class="weapon-image">
                    <img v-if="weaponForm.imageUrl" :src="weaponForm.imageUrl" alt="饰品图片"
                      style="width: 100px; height: 50px; object-fit: contain" />
                    <span v-else></span>
                  </div>
                </template>
              </van-field>

              <!-- 饰品品质选择 -->
              <van-field v-model="weaponForm.description" label="饰品赛季" readonly />
              <van-field v-model="weaponForm.quality" label="饰品品质" readonly />

              <!-- ST输入框，仅当选择了ST类别时显示 -->
              <van-field v-if="weaponForm.isStack == '1'" v-model="havaVal" label="ST" readonly />

              <!-- 模板输入框，仅当选择了模板类别时显示 -->
              <div style="display: flex; position: relative" v-if="weaponForm.isTemplate == '1'">
                <img src="@/assets/template.png" width="30px" height="30px"
                  style="position: absolute; left: 50px; z-index: 999" />
                <van-field v-model="weaponForm.template" label="模板" placeholder="请输入模板" />
              </div>
              <van-field v-else v-model="noValue" label="模板" readonly />

              <div style="display: flex; flex-direction: column" v-if="'枪' == activeWeaponCategoryText">
                <span style="font-size: 12px; font-weight: bold">贴纸查询</span>
                <van-field v-model="weaponForm.tiezhisaiji" label="贴纸赛季" placeholder="请选择贴纸赛季" is-link
                  @click="showTiezhisaiji = true" />

                <van-field v-model="weaponForm.tiezhiquatity" label="贴纸品质" placeholder="请选择贴纸品质" is-link
                  @click="showTiezhipinzhi = true" />

                <div>
                  <van-field v-model="weaponForm.tiezhi" label="获取贴纸" placeholder="请先将贴纸品质,贴纸赛季进行筛选" is-link
                    @click="showTiezhi = true" />
                  <div style="display: flex" v-if="selectTiezhiList.length > 0">
                    <div v-for="(tiezhiItem, index) in selectTiezhiList" :key="index">
                      <img :src="tiezhiItem.stickerSlot" width="30px" height="30px" style="object-fit: contain" />
                      <span style="color: red">x{{ tiezhiItem.num }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <van-field v-model="weaponForm.price" label="出售价格" placeholder="请输入价格" type="number" required
                :rules="[{ required: true, message: '请输入价格' }]">
                <template #right-icon>
                  <span class="price-unit"></span>
                </template>
              </van-field>
            </van-cell-group>
          </div>

          <!-- 提交按钮 -->
          <div class="submit-section">
            <van-button type="primary" size="small" :loading="submitLoading" @click="submitWeapon" block>
              确定上架
            </van-button>
          </div>
        </div>
      </van-popup>

      <van-popup v-model:show="showTopGengxin" position="center" :style="{ height: '80%' }" round>
        <!-- 表单内容 -->
        <div class="form-container">
          <!-- 饰品基本信息 -->
          <div class="info-section">
            <van-cell-group>
              <!-- 饰品类型选择 - 使用树形结构 -->
              <van-field v-model="weaponForm.categoryName" label="上架饰品" placeholder="请选择饰品类型" readonly is-link
                @click="showTreeSelect" required />
              <van-field label="饰品展示">
                <template #input>
                  <div class="weapon-image">
                    <img v-if="weaponForm.imageUrl" :src="weaponForm.imageUrl" alt="饰品图片"
                      style="width: 100px; height: 50px; object-fit: contain" />
                    <span v-else></span>
                  </div>
                </template>
              </van-field>
              <!-- 饰品品质选择 -->
              <van-field v-model="weaponForm.description" label="饰品赛季" readonly />
              <van-field v-model="weaponForm.quality" label="饰品品质" readonly />

              <!-- ST输入框，仅当选择了ST类别时显示 -->
              <van-field v-if="weaponForm.isStack == '1'" v-model="havaVal" label="ST" readonly />

              <!-- 模板输入框，仅当选择了模板类别时显示 -->
              <div style="display: flex; position: relative" v-if="weaponForm.isTemplate == '1'">
                <img src="@/assets/template.png" width="30px" height="30px"
                  style="position: absolute; left: 50px; z-index: 999" />
                <van-field v-model="weaponForm.template" label="模板" placeholder="请输入模板" />
              </div>
              <van-field v-else v-model="noValue" label="模板" readonly />

              <div style="display: flex; flex-direction: column" v-if="'枪' == weaponForm.category">
                <span style="font-size: 12px; font-weight: bold">贴纸查询</span>
                <van-field v-model="weaponForm.tiezhisaiji" label="贴纸赛季" placeholder="请选择贴纸赛季" is-link
                  @click="showTiezhisaiji = true" />

                <van-field v-model="weaponForm.tiezhiquatity" label="贴纸品质" placeholder="请选择贴纸品质" is-link
                  @click="showTiezhipinzhi = true" />

                <div>
                  <van-field v-model="weaponForm.tiezhi" label="获取贴纸" placeholder="请先将贴纸品质,贴纸赛季进行筛选" is-link
                    @click="showTiezhi = true" />
                  <div style="display: flex" v-if="selectTiezhiList.length > 0">
                    <div v-for="(tiezhiItem, index) in selectTiezhiList" :key="index">
                      <img :src="tiezhiItem.stickerSlot" width="30px" height="30px" style="object-fit: contain" />
                      <span style="color: red">x{{ tiezhiItem.num }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <van-field v-model="weaponForm.price" label="出售价格" placeholder="请输入价格" type="number" required
                :rules="[{ required: true, message: '请输入价格' }]">
                <template #right-icon>
                  <span class="price-unit"></span>
                </template>
              </van-field>
            </van-cell-group>
          </div>

          <!-- 提交按钮 -->
          <div class="submit-section">
            <van-button type="primary" size="small" :loading="submitLoading" @click="submitEdit" block>
              确定更新
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 饰品类别多选弹出框 -->
    <van-popup v-model:show="showCategoryTypesPicker" position="bottom" round>
      <div class="category-types-picker-container">
        <div v-for="(stack, index) in isStackList" :key="index" :index="index" class="quality-option"
          @click="handleSelectStack(stack)">
          <div class="quality-name">{{ stack.label }}</div>
        </div>
      </div>
    </van-popup>

    <!-- 饰品类型树形选择器 -->
    <van-popup v-model:show="showWeaponTreeSelect" position="bottom" round :style="{ height: '90%' }">
      <div class="tree-select-container">
        <div class="tree-select-header">
          <van-nav-bar title="选择饰品类型" left-text="取消" right-text="确认" @click-left="cancelWeaponSelect"
            @click-right="confirmWeaponSelect" />
        </div>
        <div class="tree-select-content">
          <van-tree-select v-model:main-active-index="activeWeaponCategory" :items="weaponTreeData" height="50vh"
            @update:main-active-index="onMainActiveIndexChange">
            <template #content>
              <div class="second-category" v-if="secondCategories.length > 0">
                <div v-for="(item, index) in secondCategories" :key="item.id" class="second-item"
                  :class="{ active: index == activeSecondCategory }" @click="onSecondCategoryClick(item, index)">
                  <div style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                    ">
                    <img :src="item.imageUrl" style="object-fit: contain; width: 40px; height: 40px" />
                    <span>{{ item.text }}</span>
                  </div>
                </div>
              </div>
            </template>
          </van-tree-select>
          <div class="third-category" style="
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              width: 100%;
              overflow: auto;
              max-height: 230px;
            " v-if="thirdCategories.length > 0">
            <div v-for="item3 in thirdCategories" :key="item3.id" class="third-item"
              :class="{ active: item3.id == activeWeaponId2 }" @click="onWeaponItemClick(item3)">
              <div style="
                  display: flex;
                  justify-content: flex-start;
                  margin-left: 40%;
                  align-items: center;
                  text-align: center;
                ">
                <img :src="item3.imageUrl" style="object-fit: contain; width: 40px; height: 40px" />
                <span>{{ item3.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model:show="showWeaponTreeSelect2" position="bottom" round :style="{ height: '40%' }">
      <div v-for="(item4, index) in fourCategories" :key="item4.id" class="third-item"
        :class="{ active2: index == activeWeaponIndex4 }" @click="onWeaponItemClick2(item4, index)">
        <div style="
            display: flex;
            justify-content: flex-start;
            padding-left: 30%;
            align-items: center;
          ">
          <img :src="item4.imageUrl" style="object-fit: contain; width: 40px; height: 40px" />
          <span>{{ item4.text }}</span>
        </div>
      </div>
    </van-popup>
    <!-- 饰品品质选择器 -->
    <van-popup v-model:show="showPicker" position="bottom" round>
      <div class="quality-picker-container">
        <div class="quality-options">
          <div v-for="(quality, index) in treePinzhi" :key="quality" :index="index" class="quality-option"
            @click="handleSelectQuality(quality)">
            <div class="quality-name">{{ quality }}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="showSaiji" position="bottom" round style="height: 60%">
      <div class="quality-picker-container">
        <div class="quality-options">
          <div v-for="(saiji, index) in saijiList" :key="saiji.season" :index="index" class="quality-option"
            @click="handleSelectSaiji(saiji.season)">
            <div class="quality-name">{{ saiji.season }}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 原有的饰品类型选择器（可以保留或删除） -->
    <van-popup v-model:show="showCategoryPicker" position="bottom">
      <van-picker :columns="categoryColumns" @confirm="onCategoryConfirm" @cancel="showCategoryPicker = false" />
    </van-popup>

    <div class="back-content">
      <!--      &lt;!&ndash; 状态栏切换 &ndash;&gt;-->
      <div class="status-tabs">
        <van-tabs v-model:active="currentStatus" @change="onStatusChange">
          <van-tab title="已上架" name="1"></van-tab>
          <van-tab title="已下架" name="0"></van-tab>
        </van-tabs>
      </div>

      <van-list class="card-list" scroller v-model:loading="loading" :finished="finished" finished-text="没有更多了"
        @load="onLoad">
        <!-- <div class="card-list"  ref="cardList"> -->
        <div v-for="item in tableData" :key="item.productId" class="recycle-card" @click="viewProgress(item)">
          <div class="card-content">
            <!-- 饰品图片 -->
            <div class="weapon-image">
              <van-image :src="item.imageUrl" width="80" height="80" fit="contain" />
            </div>
            <div class="template-wrapper" v-if="null != item.template && item.template">
              <img src="@/assets/template.png" width="30px" height="30px" />
              <span class="template">{{ item.template || "0" }}</span>
            </div>
            <!-- 回收信息 -->
            <div class="recycle-info">
              <div class="weapon-name">{{ item.categoryName }}</div>
              <div class="price-info">
                <span class="label">价格：</span>
                <span class="price">￥{{ item.price }} </span>
                <img style="margin-left: 5px" v-if="item.isStack == '1'" src="@/assets/st.png" alt="ST" width="26px"
                  height="16px" class="product-sales" />
              </div>
              <div class="date-info">
                <span class="label">提交日期：</span>
                <span class="date">{{ item.createdAt }}</span>
              </div>
              <!-- 贴纸图片  -->
              <div class="" v-if="item.stickerImageUrls && item.stickerImageUrls.length">
                <img style="object-fit: contain" :src="imgItem" width="30px" height="30px"
                  v-for="(imgItem, index) in item.stickerImageUrls" :key="index" :index="index" />
              </div>
            </div>

            <!-- 箭头图标 -->
            <div class="arrow-icon" v-if="currentStatus == 0">
              <van-button round type="primary" style="height: 30px" @click.stop="deleteItem(item)">删除</van-button>
              <van-button round type="primary" style="height: 30px" @click.stop="updateItem(item)">改价</van-button>
            </div>
            <div class="arrow-icon" v-if="currentStatus == 1">
              <van-button round type="primary" style="height: 30px" @click.stop="xiajiaItem(item)">下架</van-button>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </van-list>
      <div class="height-50"></div>
    </div>
  </div>

  <van-popup v-model:show="showProgressPopup" position="bottom" round :style="{ height: '60%' }">
    <div style="padding: 20px; position: relative">
      <van-icon name="cross" style="position: absolute; right: 12px; top: 12px; z-index: 2" size="22"
        @click="showProgressPopup = false" />
      <div style="text-align: center; margin-bottom: 16px">
        <van-image :src="progressItem.imageUrl" width="80px" height="80px" fit="contain" />
        <!-- <van-image v-for="imgUrl in progressItem.stickerImageUrls" :key="imgUrl" :src="imgUrl" width="40px" height="40px" fit="contain" /> -->
        <div style="font-size: 18px; font-weight: 600">
          {{ progressItem.categoryName }}
        </div>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>贴纸：</span>
        <span v-if="progressItem.tiezhiList.length == 0">无</span>
        <div v-else>
          <img v-for="(sticker, idx) in progressItem.tiezhiList" :key="sticker + idx" :src="sticker" alt="贴纸" style="
              height: 40px;
              width: 40px;
              margin-right: 4px;
              object-fit: contain;
            " />
        </div>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>品质：</span>
        <span>{{ progressItem.quality || "无" }}</span>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>模板：</span>
        <span>{{ progressItem.template || "无" }}</span>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>ST：</span>
        <span>{{ progressItem.isStack == 0 ? "否" : "是" }}</span>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>价格：</span>
        <span>￥{{ progressItem.price }}</span>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>日期：</span>
        <span>{{ progressItem.createdAt }}</span>
      </div>
      <div style="
          display: flex;
          align-items: center;
          height: 40px;
          padding-left: 20px;
        ">
        <span>状态：</span>
        <span v-if="progressItem.status == 1">已上架</span>
        <span v-if="progressItem.status == 0">已下架</span>
        <span v-if="progressItem.status == 2">已售出</span>
      </div>
      <van-button v-if="progressItem.status == 1" type="primary" size="small" @click="xiajia" block>
        下架
      </van-button>
      <div style="display: flex; justify-content: space-around">
        <van-button style="margin-right: 5px" v-if="progressItem.status == 0" type="primary" size="small"
          @click="shangjia" block>
          上架
        </van-button>
        <van-button v-if="progressItem.status == 0" style="margin-right: 5px" type="primary" size="small"
          @click="gengxin" block>
          更新
        </van-button>
        <van-button v-if="progressItem.status == 0" type="primary" size="small" @click="shanchu" block>
          删除
        </van-button>
      </div>
    </div>
    <!-- <div style="margin-bottom:8px;">价格：<span style="color:#ee0a24;font-weight:600;">{{ progressItem.price }} </span></div>
    <div style="margin-bottom:8px;">日期：{{ progressItem.createdAt }}</div>
    <div style="margin-bottom:8px;">状态：{{ getStatusText(progressItem.status) }}</div> -->
  </van-popup>

  <van-dialog v-model:show="showConfirmDialog" title="确认上架" show-cancel-button @confirm="confirmSubmit"
    @cancel="showConfirmDialog = false" confirm-button-text="确定" cancel-button-text="取消" :before-close="(action) => {
      if (action === 'confirm') {
        // console.log('confirm')
        if (!agreeProtocol) {
          return false;
        }
        return true;
      }
    }
      ">
    <div class="confirm-content" style="padding: 20px 16px">
      <div class="price-cards" style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
        ">
        <div class="price-card" style="
            flex: 1;
            background: #f0f8ff;
            border-radius: 8px;
            padding: 10px;
            margin-right: 8px;
          ">
          <div style="font-size: 14px">出售价格总计</div>
          <div style="
              color: #3b9ffb;
              font-size: 16px;
              font-weight: bold;
              margin-top: 5px;
            ">
            {{ "￥" + weaponForm.price }}
          </div>
          <div style="color: #666; font-size: 12px">
            实际收入：{{
              "￥" +
              (parseFloat(weaponForm.price) -
                parseFloat(
                  (transactionFeePercent * weaponForm.price).toFixed(2)
                ))
            }}
          </div>
        </div>

        <div class="price-card" style="
            flex: 1;
            background: #f0f8ff;
            border-radius: 8px;
            padding: 10px;
          ">
          <div style="font-size: 14px">保证金</div>
          <div style="
              color: #3b9ffb;
              font-size: 16px;
              font-weight: bold;
              margin-top: 5px;
            ">
            {{
              "￥" +
              parseFloat((earnestMoneyPercent * weaponForm.price).toFixed(2))
            }}
          </div>
          <div style="color: #666; font-size: 12px">下架，交易成功自动退回</div>
        </div>
      </div>
      <!-- <p style="text-align: center;color: #e94259;font-weight: bold;">转换比例:10=1RMB</p> -->
      <!-- <p>上架饰品需要交<span style="font-weight: bold;">保证金</span>{{ parseFloat((earnestMoneyPercent * weaponForm.price).toFixed(2)) }} </p> -->
      <!-- <p style="text-align: center;">需要交<span style="font-weight: bold;">保证金</span>{{ parseFloat((earnestMoneyPercent * weaponForm.price).toFixed(2)) }} </p>
    <p style="text-align: center;">需要交<span style="font-weight: bold;">平台手续费</span>{{ parseFloat((transactionFeePercent * weaponForm.price).toFixed(2)) }} </p> -->
      <!-- <p>需要交<span style="font-weight: bold;">手续费</span>{{ parseFloat((transactionFeePercent * weaponForm.price).toFixed(2)) }} </p> -->
      <!-- <p>确定上架饰品吗?</p> -->
      <div class="protocol-checkbox" style="margin-top: 15px">
        <van-checkbox v-model="agreeProtocol">
          我已阅读并支付保证金
          <span style="color: #1989fa" @click.stop="showProtocol">《上架协议》</span>
        </van-checkbox>
      </div>
    </div>
  </van-dialog>

  <van-popup v-model:show="showTiezhisaiji" position="bottom" round :style="{ height: '50%' }">
    <div class="quality-picker-container">
      <div class="quality-options">
        <div v-for="(item, index) in tiezhisaijiList" :key="item.season" :index="index"
          :class="{ 'quality-selected': selectedSaijiId === item.season }" @click="changeSaiji(item)">
          <div class="quality-name">{{ item.season }}</div>
        </div>
      </div>
    </div>
  </van-popup>

  <van-popup v-model:show="showTiezhipinzhi" position="bottom" round>
    <div class="quality-picker-container">
      <div class="quality-options">
        <div v-for="(item, index) in treePinzhi" :key="item" :index="index"
          :class="{ 'quality-selected': selectedPinzhiId == item }" @click="changePinzhi(item)">
          <div class="quality-name">{{ item }}</div>
        </div>
      </div>
    </div>
  </van-popup>

  <van-popup v-model:show="showTiezhi" position="bottom" round :style="{ height: '50%' }">
    <div class="quality-picker-container">
      <div class="quality-picker-header">
        <van-nav-bar title="选择饰品贴纸" left-text="取消" right-text="确认" @click-left="showTiezhi = false"
          @click-right="confirmTiezhiSelect" />
      </div>
      <div class="quality-options">
        <div v-for="(item, index) in tiezhiList" :key="item.stickerSlot" :index="index">
          <div @click="changeTiezhi(item)" class="quality-name" :class="{ 'quality-selected': item.checked }"
            style="display: flex">
            {{ item.stickerSeason }}
            <img :src="item.stickerSlot" />
          </div>
          <div>
            <van-stepper @change="changeNum(item)" v-model="item.num" />
          </div>
        </div>
      </div>
    </div>
  </van-popup>

  <!-- <van-tabbar route>
    <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
    <van-tabbar-item replace to="/market" icon="search">市场</van-tabbar-item>
    <van-tabbar-item replace to="/stock" icon="shop-o">出售</van-tabbar-item>
    <van-tabbar-item replace to="/back" icon="after-sale">回收</van-tabbar-item>
    <van-tabbar-item replace to="/proxyPlay" icon="diamond-o">代充</van-tabbar-item>
    <van-tabbar-item replace to="/profile" icon="user-o">我的</van-tabbar-item>
  </van-tabbar> -->

  <van-dialog v-model:show="showConfirmMsg" title="交易提示" show-cancel-button @confirm="handleConfirm"
    @cancel="showConfirmMsg = false" confirm-button-text="继续操作" cancel-button-text="取消"
    :before-close="beforeDialogClose">
    <div class="trade-notice" style="padding: 20px 16px">
      <div class="notice-title" style="
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        ">
        商家出售饰品被脚本截胡，承担全部责任！！！
      </div>

      <div class="notice-section">
        <h3 style="font-size: 16px; margin-bottom: 10px">1、商家责任</h3>
        <van-notice-bar color="#000" background="#f5f5f5" :scrollable="false" wrapable>
          上架商品后，需要<span style="color: red">24小时</span>内进行发货商品<span style="color: red">交易被截胡、超时发货</span>扣除<span
            style="color: red">全部</span>保证金，<span style="color: red">保证金x70%</span>赔付平台，<span
            style="color: red">保证金x30%</span>赔付给买家用户，并原路退还该笔订单的全部金额给买家
        </van-notice-bar>
      </div>

      <div class="notice-section" style="margin-top: 20px">
        <h3 style="font-size: 16px; margin-bottom: 10px">2、交易纠纷</h3>
        <van-notice-bar color="#000" background="#f5f5f5" :scrollable="false" wrapable>
          双方<span style="color: red">互相督促录制</span>交易时的视频，双方有<span
            style="color: red">交易纠纷</span>时，提交给客服该视频，作为主要证据（1-3个工作日）
        </van-notice-bar>
      </div>

      <div class="checkbox-section"
        style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
        <van-checkbox v-model="readAndAgree" shape="square">
          我已知上述情况
        </van-checkbox>
        <van-checkbox v-model="free" shape="square">
          30天免提示
        </van-checkbox>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import request from "@/utils/request";
import { showToast, showDialog, showConfirmDialog } from "vant";
export default {
  name: "StockPage",
  data() {
    return {
      showTop: false,
      showTopGengxin: false,
      showSidebarPopup: false,
      showPicker: false,
      showSaiji: false,
      saijiList: [],
      filterForm: {
        category: "",
      },
      // 饰品表单数据
      noValue: "无",
      havaVal: "是",
      //保证金
      earnestMoneyPercent: "",
      //手续费
      transactionFeePercent: "",
      showTiezhisaiji: false,
      showTiezhipinzhi: false,
      showTiezhi: false,
      selectTiezhiImg: [],
      weaponForm: {
        stickers: [],
        stickersText: "",
        name: "",
        category: "",
        rarity: "",
        wear: "",
        price: "",
        description: "",
        allowBargain: true,
        immediateList: true,
        // 新增字段
        categoryTypes: [], // 存储选中的类别：normal, template, st
        categoryTypesText: "", // 用于显示在输入框中
        templateValue: "", // 模板值
        stValue: "", // ST值
        categoryId: "", // 分类ID
        categoryName: "", // 分类名称
        tiezhi: [],
      },

      // 图片上传
      weaponImages: [],

      // 选择器显示状态
      showCategoryPicker: false,
      showRarityPicker: false,
      showWearPicker: false,
      showQualityPicker: false,
      showWeaponTreeSelect: false,
      showWeaponTreeSelect2: false,
      showCategoryTypesPicker: false, // 新增饰品类别选择器显示状态,
      isStackList: [
        { label: "是", value: "1" },
        { label: "否", value: "0" },
      ],
      showStickerPicker: false, // 控制贴纸下拉弹窗显示
      // 树形选择器相关数据
      activeWeaponCategory: 0,
      activeWeaponCategoryText: "",
      activeSecondCategory: -1,
      activeWeaponId: 0,
      activeWeaponId2: 0,
      selectedWeapon: null,
      selectedQualityId: "",
      weaponCategories: [],
      secondCategories: [],
      thirdCategories: [],
      fourCategories: [],
      activeWeaponIndex4: null,
      showConfirmDialog: false, // 控制确认弹框显示
      showConfirmMsg: false,
      readAndAgree: false,
      free: false,
      agreeProtocol: false,

      // 提交状态
      submitLoading: false,
      page: 1,
      pageSize: 10,

      // 显示的数据列表（用于分页加载）
      displayData: {
        //已上架
        isShelves: [],
        //交易中
        dealing: [],
        //已交易
        over: [],
      },
      tableData: [],
      total: 0,
      loading: false,
      finished: false,
      currentStatus: 1,
      pageNum: 0,
      checkedStickers: [], // 贴纸弹窗里的临时多选
      showProgressPopup: false,
      progressItem: {},
      weaponTreeData: [],
      tiezhisaijiList: [],
      selectedSaijiId: "",
      selectedPinzhiId: "",
      tiezhiList: [],
      selectTiezhiList: [],
      treePinzhi: [],
      userinfo: {},
      submitTimer: null, // 添加防抖定时器
    };
  },
  created() {
    request.get("/front/weapon/season/list").then((res) => {
      if (res.code == 200) {
        this.saijiList = res.data.seasonList;
      }
    });
    this.userinfo = this.$store.state.user.userInfo;
    this.get_pinzhi();
    this.get_tiezhisaiji();
    // this.pageNum = 1
    // this.getList()
    //获取上架饰品
    request.get("/front/weapon/category").then((res) => {
      if (res.code == 200) {
        this.weaponTreeData = [];
        this.weaponTreeData = this.getTreeList(
          res.data.weaponCategories,
          this.weaponTreeData
        );
        // console.log(this.weaponTreeData)
      }
    });
  },
  mounted() { },
  computed: {},
  methods: {
    updateItem(item) {
      this.progressItem = item;
      this.gengxin();
    },
    deleteItem(item) {
      this.progressItem = item;
      this.shanchu();
    },
    xiajiaItem(item) {
      this.progressItem = item;
      this.xiajia();
    },
    handleSelectStack(v) {
      this.filterForm.isStackLable = v.label;
      this.filterForm.isStackValue = v.value;
      this.showCategoryTypesPicker = false;
    },
    handleSelectQuality(v) {
      this.filterForm.quality = v;
      this.showPicker = false;
    },
    handleSelectSaiji(v) {
      this.filterForm.description = v;
      this.showSaiji = false;
    },
    // 添加防抖函数
    debounceSubmit(callback, delay = 1000) {
      if (this.submitTimer) {
        console.log("已存在定时器，取消上一次请求");
        clearTimeout(this.submitTimer);
      }
      this.submitTimer = setTimeout(() => {
        callback();
        this.submitTimer = null;
      }, delay);
    },
    confirmSubmit() {
      try {
        if (!this.agreeProtocol) {
          showToast("请先阅读并同意《上架协议》");
          return;
        }

        // 使用防抖包装上架请求
        this.debounceSubmit(() => {
          let stickerUrls = [];
          if (this.selectTiezhiList.length > 0) {
            this.selectTiezhiList.forEach((item, index) => {
              for (let i = 0; i < item.num; i++) {
                stickerUrls.push(item.stickerSlot);
              }
            });
          }

          request
            .post("/front/weapon/add", {
              stickerUrls: stickerUrls.length > 0 ? stickerUrls.join(",") : "",
              categoryId: this.weaponForm.categoryId,
              quality: this.weaponForm.quality,
              template: this.weaponForm.template,
              isTemplate: this.weaponForm.isTemplate,
              isStack: this.weaponForm.isStack,
              price: this.weaponForm.price,
            })
            .then((res) => {
              if (res.code == 200) {
                showToast("上架成功");
                this.search();
                this.showTop = false;
              } else {
                showToast(res.msg);
              }
            });
        });
      } catch (error) {
        console.log(error);
      }
    },
    showProtocol() {
      showDialog({
        title: "上架协议",
        message: `<div class="protocol-container">
        <div class="header">
            <h1>皮皮售饰品交易回收平台出售业务服务协议</h1>
            <div class="subtitle">2025年08月5日生效版本</div>
            <p>本《皮皮售饰品交易回收饰品交易回收平台出售业务服务协议》（下亦简称“本协议”或”皮皮售饰品交易回收平台“）的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除一切冲突法的适用</p>
            <p>买卖双方注意重点关注<strong>第【三】条</strong>的交易规则</p>
            <p>协议更新时间：2025年8月5日9:00</p>
            <p>协议生效时间：2024年8月5日10:00</p>
        </div>
        
        <div class="important-note">
            <p>本协议约定了平台所提供的服务、平台交易规则、如何保障用户权益及纠纷的解决方式等问题。请在交易前，详细阅读本协议所有内容。如您为卖方请代入甲方条款适用，如您为买方请代入乙方条款适用，丙方为平台方。</p>
        </div>
        
        <p>本协议约定的交易模式为“出售）。即乙方在购买过程，可以选择支付或者取消订单。甲方知悉在通过“出售”上架饰品时，乙方可在饰品上架期间均有权选择购买该商品。</p>
        
        <h2>甲乙丙三方关系说明：</h2>
        
        <h3>【甲方】</h3>
        <p>是指自愿签署《出售业务服务协议》，且已阅览并同意本协议所有条款，认可本协议的法律效力，认同丙方平台的商业模式，通过丙方运营平台出售商品或饰品的用户。</p>
        
        <h3>【乙方】</h3>
        <p>是指自愿签署《出售业务服务协议》，且已阅览并同意本协议所有条款，认可本协议的法律效力，认同丙方平台的商业模式，通过丙方运营平台下单购买甲方商品的用户。</p>
        
        <h3>【丙方】</h3>
        <p>是负责为本协议项下的出售服务提供系统支持及信息技术支持等服务的网络交易平台，是为甲乙双方提供技术和服务支持的在线交易平台，该平台名为“皮皮售饰品交易回收平台”由台州市范成电子商务有限公司开发运营。</p>
        
        <div class="important-note">
            <h3>特别提醒：</h3>
            <p>1、在此特别提示您阅读本协议的各个条款，尤其是以粗体、下划线等标识的条款，包括但不限于<strong>第【三】条违约的处理</strong>、<strong>第【十】条争议解决条款</strong>、<strong>第【十一】条合同效力</strong>、<strong>第【十二】条通知及送达条款</strong>及附件-《个人信息查询授权书》等可能限制或影响您责任的相关条款。甲方及丙方通过本协议向乙方提供出售服务，如乙方通过点击确认、勾选同意等方式在平台或其他客户端确认本协议，或通过电子签名的方式在电子合同平台签署本协议，即视为乙方已阅读并同意本协议所有条款，且对本协议条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本协议的约束。</p>
            
            <p>2、甲方确认并承诺：甲方已明确知晓使用皮皮售饰品交易回收平台的交易规则，同意并认可出售的饰品“出售”的交易模式；丙方按照本协议约定向乙方主张相关权益时，如需甲方配合，甲方应予以积极配合；</p>
            
            <p>3、乙方确认并承诺：乙方已明确知晓乙方登陆皮皮售饰品交易回收平台前已同意授权皮皮售饰品交易回收获取乙方的支付宝账号信息，使用该支付宝账号在皮皮售饰品交易回收平台进行的任意行为均视为乙方本人的行为，乙方对上述行为承担一切责任及法律后果；乙方同意并认可购买出售的饰品“出售”的交易模式。</p>
            
            <p>4、如果您不同意本协议的任意内容，或者无法准确理解本协议相关条款，请不要进行后续操作。如您对本协议有任何疑问，确认签署本协议之前请联系平台官方客服进行咨询，皮皮售饰品交易回收客服将竭诚为您服务并作出解释。</p>
            
            <p>5、丙方运营皮皮售饰品交易回收平台、H5页面、显示的商品或服务信息随时都可能发生变动，丙方运营皮皮售饰品交易回收平台的网站、小程序、H5页面中的文字表述、图片效果可能被实时修改和调整，对于此类变化和调整，丙方可能无法及时做特别通知。丙方运营皮皮售饰品交易回收平台的网站内展示的标的物规格、参数、库存等商品信息将尽可能准确、详细并与实际产品信息相匹配，但由于网站上商品信息的数量极其庞大，且受互联网技术发展水平（如网络延迟、设备配置）等因素的限制，丙方运营皮皮售饰品交易回收平台的网站、H5页面等不排除部分信息会存在滞后或差错的可能性。甲方、乙方确认：对此情形您表示知悉并理解，并同意不追究丙方的相关责任。</p>
            
            <p>6.本协议签订于台州市范成电子商务有限公司办公地点。如各方就本协议的内容或其执行发生任何争议（包括但不限于协议或者其他财产性权益纠纷），各方应友好协商解决；协商不成时，各方同意交由本协议签订地有管辖权的人民法院管辖并处理。</p>
        </div>
        
        <h2>一、定义或名词解释</h2>
        
        <div class="definition-list">
            <dl>
                <dt>1.1、Standoff2中文名全称《对峙2》（下文称为对峙2）</dt>
                <dd>是由俄罗斯公司ALEXT公司开发的第一人称射击游戏。</dd>
                
                <dt>1.2、饰品</dt>
                <dd>是指对峙2游戏内所存在的、可在对峙2内的不同账号之间流转的游戏资源、游戏道具等可归属于特定主体的财产或财产性权益（包括但不限于游戏中的武器、装备、皮肤等），在本协议中，也可用"商品"来指代饰品，在饰品上架后期间，丙方用商品来指代饰品。</dd>
                <dd>本协议以及皮皮售饰品交易回收平台相关页面中所描述的"售卖"、"出售"、"售"、"购买"、 "上架"等用词，均指且仅指前述财产或财产性权益及其交易对价在特定主体之间的流转行为。</dd>
                
                <dt>1.3、截胡</dt>
                <dd>是指甲方和乙方之间进行饰品交易期间， 出现甲方商品在交易时出现失误没有准确无误的转移到乙方手中</dd>
                
                <dt>1.4、交易失败</dt>
                <dd>是指甲方和乙方交易期间商品出现了"超时"，"截胡"，"货不对板"等没有成功到账的情况统称为交易失败</dd>
            </dl>
        </div>
        
        <h2>二、关于商品</h2>
        
        <p>2.1、本协议所称商品是指用户通过皮皮售饰品交易回收发布出售的游戏装备等虚拟物品，也称饰品。</p>
        
        <p>2.2、乙方在下单购买商品前应当向丙方提供自己的真实姓名和身份证号码，同时还应当提供准确的联系地址及联系方式（包括但不限于手机号码、微信、钉钉、邮箱等），该联系方式适用于第十二条所列内容。乙方联系方式及地址变更须及时通知丙方，否则视为未予变更，由此导致的一切损失，应由乙方承担。</p>
        
        <p>2.3、甲方在交货商品过程中，需确保商品完好，所有权无争议，未经乙方同意，不得对交货中的商品有以下行为：包括但不限于更改游戏道具名称、属性、外观、功能改变等破坏商品的行为，商品必须安全</p>
        
        <p>2.4、饰品上架，甲方上架饰品过程中，为了方便，甲方可以免费使用丙方为提高定价效率所提供的定价手段，上架的饰品定价均需要甲方再次核对确认。</p>
        <p>甲乙双方完成交易后，若甲方认为交易商品价格不符合预期，由甲方自行承担，甲方确认丙方不因提供方便甲方定价的手段而承担责任。</p>
        
        <p>出于保障乙方用户正常商品购买的权利，甲方上架时填写的价格金额需要保证其合理性，若甲方存在恶意定价扰乱市场的情况，丙方有权利封禁甲方账户部分交易权限。</p>
        
        <p>2.5、丙方所提供的饰品、商品检视图效果仅供参考，商品交付的实际样式以对峙2游戏内呈现为准，乙方予以确认。</p>
        
        <p>甲乙双方完成交易后，若乙方发现交易商品在对峙2游戏中的样式与丙方提供该商品的上架商品存在差异，由甲乙双方协商解决，丙方可视情况决定是否居中协调，甲乙双方认可丙方不因此承担任何责任，即确认丙方选择做协调工作也并不意味丙方需要承担责任。</p>
        
        <h2>三、交易规则</h2>
        
        <p>3.1、鉴于皮皮售饰品交易回收平台仅为一个基于互联网的交易平台，台州市范成电子商务有限公司并不参与用户之间的磋商、付款、交付等交易环节。用户确认并同意后再创建，皮皮售饰品交易回收平台的预估价、参考价、市场价等，仅仅是台州市范成电子商务有限公司为了更好地服务用户而提供给用户的参考信息，任何时候任何情况下，台州市范成电子商务有限公司的上述行为均不得被认为是对交易标的价格的合理性、交易标的来源的合法性等进行的任何明示或默示的担保或保证。</p>
        <p>出于保障用户的合法权益之必要，用户均同意授权台州市范成电子商务有限公司根据本协议约定及皮皮售饰品交易回收平台规则对发生在皮皮售饰品交易回收平台上的交易进行监管，用户对台州市范成电子商务有限公司据此进行的审查、调查、限制、处罚、责任追究等予以认可。</p>
        
        <p>3.2、针对甲方上架商品时需缴纳3%此商品金额的保证金 当乙方购买后，甲方订单交易"发货超时（超过24小时）"、"商品被截胡"，丙方扣除甲方保证金x70%赔付给甲方平台，甲方保证金x30%赔付给乙方用户 并记作"超时发货1次"</p>
        <p>当甲方向乙方发货时，双方应该需同时录制交易视频，双方后续发生争议可依靠双方视频就行判断决策</p>
        <p>当甲方未成功发货或该商品因甲方原因"失误"，"看走眼"等截胡导致乙方未能获得该商品，甲方需承担该商品的所有丢失责任，皮皮售饰品交易回收平台有权将全部商品金额原路退还给乙方。</p>
        <p>若此次丢件有关甲方和乙方产生的任何纠纷，首先由双方协商解决，若双方不能达成共识，可申请丙方予以协助，丙方将按照本协议约定及出售物详情页中的相关规定进行判定，如果本协议约定及出售物详情页中的相关规定不能解决相关问题，则丙方将依据一般人的认知程度对该争议进行判断和处理。双方对丙方的判断和处理不服的，双方可另行通过法律途径解决。</p>
        
        <p>3.3、若用户账户被盗、遭遇黑客攻击或出现其他异常情形的，在用户向台州市范成电子商务有限公司提出或台州市范成电子商务有限公司主动发现异常的情况下，为保护用户合法权益，台州市范成电子商务有限公司有权就用户账户及交易展开调查，并对用户的账户采取保护性的处理措施，包括但不限于暂时限制账户操作、皮皮售饰品交易回收平台使用权限降级（包括但不限于限制提现、出售、购买、饰品、商品检视、昵称修改等）、资金冻结、中止或终止交易、撤销交易等。</p>
        
        <p>3.4、交易完成后，若经任何第三方举报或台州市范成电子商务有限公司主动发现交易异常的情形下，台州市范成电子商务有限公司有权对已完成交易展开调查，若经调查发现已完成交易确属违反法律法规或本协议，台州市范成电子商务有限公司将有权撤销该交易，在用户的皮皮售饰品交易回收平台账户余额中扣除等额的交易款项、限制或禁止用户使用皮皮售饰品交易回收平台账户、限制或禁止用户提取皮皮售饰品交易回收平台账户余额等。</p>
        
        <p>3.5、您应知悉，由于网络服务的特性和复杂性，台州市范成电子商务有限公司可能难以及时发现用户账户或交易的异常情况，故为保障您的合法权益，请密切关注您的账户和交易情况，一旦发生异常请及时与台州市范成电子商务有限公司联系。</p>
        
        <p>3.6、商品（包含印花）交货成功时，系统将自动验货，若发现当前商品的印花信息与创建订单时的商品快照（即商品详情总览）不一致的，会将订单进入到延时结算，并向乙方发送通知，乙方可自行在游戏中验货，在延时结算状态下，可联系客服介入请求部分退款，超过2个小时（即延时阶段状态为两小时内）乙方未联系，视为乙方确认无误，资金自动结算给甲方；</p>
        
        <h2>四、支付方式</h2>
        
        <p>丙方提供包括支付宝、微信、皮皮售饰品交易回收钱包余额、等支付方式。</p>
        <p>为了确保交易安全，维护交易规则，订单中涉及到的交易款项，甲方和乙方均同意由丙方代收代付。</p>
        
        <h2>五、甲方权利与义务</h2>
        
        <p>5.1、甲方保证所出售的商品享有法律上完整的所有权、处分权。保证没有任何权属瑕疵及其他法律纠纷。因甲方出售商品的所有权瑕疵或纠纷，导致乙方在收取商品后产生争议或纠纷，甲方需配合乙方处理并赔偿给乙方带来的损失。</p>
        
        <p>5.2、甲方应按乙方订单要求发货，确保商品信息与订单中标明的一致，并有权按照出售服务协议订单显示价格收取相应的售价。</p>
        
        <p>5.3、乙方收货后，在使用商品过程中造成人身损害、财产损失的，甲方不承担任何责任。</p>
        
        <p>5.4、丙方按照本协议约定向乙方主张权益时，如需甲方配合，甲方应予以积极配合。</p>
        
        <h2>六、乙方权利与义务</h2>
        
        <p>6.1、乙方在出售完成后拥有购买商品的合法所有权、使用权，乙方需合理使用该商品。</p>
        
        <p>6.2、按本出售服务协议的约定按时、足额向甲方支付售价并且及时收货。</p>
        
        <p>6.3、乙方须是具有完全民事行为能力的成年人，乙方使用购买商品时应遵守相关法律、法规，合理合法使用购买的商品。不得利用购买的商品从事违法犯罪活动，不得利用购买的商品侵害他人合法权益；因乙方违规使用购买的商品所产生的一切法律纠纷及法律责任由乙方自行解决、承担。</p>
        
        <h2>七、丙方权利与义务</h2>
        
        <p>7.1、丙方承诺不泄漏甲方、乙方在丙方留存的账户及个人身份信息。</p>
        
        <p>7.2、乙方在使用购买商品过程中造成人身损害、财产损失的，由乙方自行承担，丙方对乙方的损害和损失不承担任何责任。</p>
        
        <p>7.3、丙方对甲乙双方之间的出售服务业务有监督的权限，对甲乙双方的投诉应及时协调和处理。</p>
        
        <h2>第八条 责任限制</h2>
        
        <p>8.1、丙方对不可抗力导致的损失不承担责任。本协议所指不可抗力包括：天灾、法律法规、政府指令的变更、第三方应用平台原因、因网络服务特性而特有的原因（例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、突发性的软硬件设备及电子通信设备故障、互联网覆盖范围限制、计算机病毒、黑客攻击等因素等），及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</p>
        
        <p>8.2、甲乙双方理解并同意，丙方的服务是按照现有技术和条件所能达到的现状提供的。丙方会尽最大努力向您提供服务，确保服务的连贯性和安全性；但丙方不能随时预见和防范技术风险以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、第三方服务干涉、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。丙方不能确保您从皮皮售饰品交易回收平台下载的任何资料或其他数据无病毒、无污染或不具破坏性。</p>
        <p>由于网络环境特殊性及网络第三方不确定安全因素，丙方不承诺皮皮售饰品交易回收平台或皮皮售饰品交易回收平台的任何内容、服务或功能无任何错误或不中断，不承诺任何瑕疵将被纠正，或者您对皮皮售饰品交易回收平台的使用将产生特定结果。</p>
        <p>如果对皮皮售饰品交易回收平台或任何内容有任何不满意，您应当停止使用皮皮售饰品交易回收平台或任何该等内容。</p>
        
        <p>8.3 对发生下列情形造成的不便或损害，丙方不承担责任：</p>
        <p>(1)为了更好地为用户提供专业、便捷的服务而进行的网站和服务器的定期检查或施工、更新软硬件而造成的服务中断；</p>
        <p>(2)网络服务提供商线路或其他故障；</p>
        <p>(3)在紧急情况之下依照法律的规定或政府部门的指令而采取的措施；</p>
        <p>(4)用户与其它任何第三方的纠纷；</p>
        <p>(5)丙方根据已经生效的法律文书以及有效政府文件的要求进行的任何操作；</p>
        <p>(6)其他非丙方原因导致的情形。</p>
        
        <p>8.4、鉴于交易标的的特殊性，皮皮售饰品交易回收平台无法鉴别和判断相关交易各主体之民事行为能力、资质、信用等状况，也无法鉴别和判断交易标的之来源、权属、真伪、性能、规格、质量、数量等属性及状况。因此，您在交易前应加以仔细辨明，并慎重考虑和评估交易可能产生的各项风险并自行承担由此带来的后果。</p>
        
        <h2>第九条 隐私条款</h2>
        
        <p>9.1 本协议所指的"隐私"包括《电信和互联网用户个人信息保护规定》第4条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。</p>
        
        <p>9.2 当甲乙双方注册皮皮售饰品交易回收个人账户并接受使用平台出售服务时，甲乙双方须向丙方提供必要个人信息。丙方收集个人信息的目的是为用户提供尽可能多的个人服务以及风险评估，从而更好的为乙方提供出售服务，在此过程中，丙方承诺不会泄露甲乙双方个人信息。</p>
        
        <p>9.3 丙方不会在未经合法用户授权时，公开、编辑或透露其个人信息及保存在丙方中的非公开内容，除非有下列情况:</p>
        <p>(1)事先获得用户的明确授权。</p>
        <p>(2)根据有关的法律法规要求。</p>
        <p>(3)按照相关政府主管部门或有关司法机关的要求。</p>
        <p>(4)丙方维护自身权益的需要。</p>
        
        <h2>第十条 争议解决</h2>
        
        <p>因本协议履行过程中引起的或与本协议相关的任何争议，三方应以友好协商的方式解决，若经协商仍未解决，三方均应向本协议签订地有管辖权的人民法院提起诉讼解决，守约方为实现债权所产生的案件受理费、诉讼保全费、公告费、公证费、律师费、差旅行费等一切费用由违约方承担。</p>
        
        <h2>第十一条 合同效力</h2>
        
        <p>11.1、本协议自乙方在确认订单页点击勾选本协议，且提交订单成功，合同成立且生效。</p>
        
        <p>11.2、本协议有效期自乙方下单购买支付成功且商品最终到达乙方库存内之日止。</p>
        
        <p>11.3、乙方下单网页页面、甲方发货凭证、交易快照等均是本协议附件，与本协议有同等法律效力。若记载内容存在冲突，以丙方运营后台记载的信息为准。</p>
        
        <h2>第十二条 通知和修订</h2>
        
        <p>12.1、 丙方为了更好的服务甲乙双方，随着业务发展及政策变化，本协议可能随之修改和更新。丙方更新本协议时，需在生效前，通过在皮皮售饰品交易回收网站、皮皮售饰品交易回收移动端公告或其他适当方式提醒甲乙双方相关内容的修改和更新。</p>
        
        <p>12.2 、本协议履行过程中，丙方发送给甲方、乙方的书面通知，书面通知的形式包括但不限于甲方或丙方采用平台公告、平台站内信息、APP弹窗推送、发送电子邮件、手机短信、电话、钉钉、微信等现代化电子通讯方式。以邮寄送达的，按照甲方、乙方填写的送达地址。自书面通知交邮后的第五个自然日视为送达；在采用上述电子方式进行书面通知的情况下发送当日即视为送达。</p>
        
        <p>12.3 、丙方有权决定以前述任何一种或几种形式书面通知用户。丙方以多种方式向用户发送通知的，通知送达时间以最先送达的为准。</p>
        
        <p>12.4、甲方、乙方通讯地址和通讯方式默认为甲乙双方在丙方平台注册和交易时提供电话号码、电子邮箱及送达地址。甲方、乙方同意，默认通讯方式可以适用于司法送达。</p>
        
        <p>12.5、如果甲乙双方上述送达地址有变更本人应当及时告知丙方和司法机关变更后的送达地址。</p>
        
        <p>12.6、甲方和乙方承诺，已完全阅读所有条款，并保证上述送达地址是准确的、有效的；如果提供的送达地址不准确，或不及时告知变更后的地址，使法律文书无法送达或未及时送达，由甲方和乙方自行承担由此产生的一切法律后果。</p>
        
        <p>12.7、若发生纠纷(包括但不限于交货产品交货成功后发现严重破损或与创单的交易快照不符、差距过大等)，为保证依法依约提起诉讼主张权利的诉讼文书及时、准确送达给甲方乙方，甲方、乙方确认的送达地址、系本人真实意思表示。甲方、乙方确认的上述地址不真实、不准确(包括但不限于地名变更、地址被拆迁、确认的地址中无人签收文书等情形)，导致人民法院的相关文书未能实际由本人签收，视同已收到人民法院寄送的相关文书。邮件退回之日，视为送达之日。</p>
        <p>如人民法院等司法机关使用电子送达，向甲方、乙方预留电话号发送电子送达信息之日视为送达之日。</p>
        <p>甲方、乙方均承诺如变更上述送达地址、电话的，将在5个工作日内书面或邮件通知更改送达地址；若因未及时书面通知和更改确认书，导致人民法院的相关文书未能实际由本人签收，将视同本人已收到人民法院寄送的相关文书。邮件退回之日、信息发送之日视为送达之日。甲方、乙方对人民法院寄送的相关文书、电子送达的信息，应诚实收取；若人民法院按上述地址寄送相关文书，收件人拒绝签收或因其他不可抗力的任何原因导致相关文书退回的，将视同本人已收到人民法院寄送的相关文书。邮件退回之日，视同送达之日。</p>
        
        <h2>第十三条</h2>
        
        <p>甲乙丙三方承诺，已完全阅读所有条款，并保证已理解上述条款的准确意义，由本协议产生的法律后果各方自愿承担。</p>
        
        <h2>附件一: 个人信息查询授权书</h2>
        
        <div class="important-note">
            <p>[特别提示]本授权书以数字电文形式签订，在签订授权书之前，请申请人务必仔细阅读本授权书的全部条款，关注您在授权书中的权利和义务。授权人(即申请人)本人同意并不可撤销地授权皮皮售饰品交易回收平台，在本次购买过程中(自购买下单至购买订单完结结束)，基于约定用途:包括但不限于担保或依法或经有权部门要求等，有权通过第三方服务机构( 包括但不限于中国人民征信中心等第三方权威征信机构、第三方服务机构及其关联公司以及第三方数据机构等)对申请人提交的个人信息进行核实，有权通过前述第三方服务机构采集申请人的运营商信息、借贷信息、消费信息、财务信息等个人信息(包括可能对本人产生负面影响的不良信息)用于为申请人提供风控、出售、购买、出售交易过程管理等金融服务。申请人已被明确告知提供上述信息可能 会给本人带来经济、声誉损失等不利后果，但本人仍然同意授权查询主体通过第三方服务机构采集相关信息。授权人本人同意并不可撤销地授权皮皮售饰品交易回收平台向第三方服务机构提供个人信息及借贷信息(含办理业务时产生的不良信息)以判断、识别业务风000000000000000000000000000000务机构依 据法律法规就授权范围内对上述本人信息进行采集、获取、存储、处理、提供、传输、披露。授权人本人同意并授权甲方及丙方将本人个人信息及履约情况提供给包括但不限于金融信用信息基础数据库、中国人民银行批准成立的征信机构、政府公共信用信息平台、银行、非银行金融机构、电信运营商、征信公司、甲方及丙方的关联公司及合作机构等，以供有关单位、部门及个人查询和使用。授权人本人承诺本授权效力具有独立性，不因其他合同的任何条款无效而无效。 授权人本人已知悉本授权书所有内容的意义及由此产生的法律效力，自愿作出上述授权，本授权申明是授权人本人真实的意思表示，本人同意承担由此带来的一切法律后果。</p>
            <p>特此授权!</p>
        </div>
        
        <div class="footer">
            <p>台州市范成电子商务有限公司</p>
            <p>皮皮售饰品交易回收平台</p>
            <p>2025年8月5日</p>
        </div>
    </div>`,
        messageAlign: "left",
        scrollable: true,
        maxHeight: "90vh",
        allowHtml: true,
        // confirmButtonText: '我已阅读并同意',
        showCancelButton: false,
      });
    },
    showTreeSelect() {
      if (this.weaponTreeData.length > 0) {
        this.onMainActiveIndexChange(0);
      }

      this.showWeaponTreeSelect = true;
    },
    getTreeList(list, datas) {
      list.forEach((item) => {
        let o = {};
        o.text = item.categoryName;
        o.id = item.categoryId;
        o.imageUrl = item.imageUrl;
        o.isStack = item.isStack;
        o.isTemplate = item.isTemplate;
        o.description = item.description;
        o.quality = item.quality;
        o.children = [];
        if (item.children && item.children.length > 0) {
          o.children = this.getTreeList(item.children, []);
          datas.push(o);
        } else {
          datas.push(o);
        }
      });
      return datas;
    },
    getList() {
      if (this.finished) {
        return false;
      }
      request
        .get("/front/weapon/self/list", {
          params: {
            categoryName: this.filterForm.categoryName,
            quality: this.filterForm.quality,
            template: this.filterForm.template,
            isStack: this.filterForm.isStackValue,
            description: this.filterForm.description,
            //0下架 1上架
            status: this.currentStatus,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (this.pageNum === 1) {
              this.tableData = res.rows;
            } else {
              this.tableData = [...this.tableData, ...res.rows];
            }
            this.total = res.total;

            // 判断是否加载完成
            this.finished = this.tableData.length >= res.total;
          }
        })
        .finally(() => {
          // 请求完成后再设置 loading 为 false
          this.loading = false;
        });
    },
    get_pinzhi() {
      request.get("/front/weapon/quality/list").then((res) => {
        if (res.code == 200) {
          this.treePinzhi = res.data.qualityList;
        }
      });
    },
    get_tiezhisaiji() {
      request.get("/front/weapon/season/list").then((res) => {
        if (res.code == 200) {
          this.tiezhisaijiList = res.data.seasonList;
        }
      });
    },
    changeSaiji(item) {
      this.weaponForm.tiezhisaiji = item.season;
      this.selectedSaijiId = item.season;
      this.showTiezhisaiji = false;
      if (this.weaponForm.tiezhisaiji && this.weaponForm.tiezhiquatity) {
        request
          .get("/front/weapon/sticker/list", {
            params: {
              categoryId: this.weaponForm.categoryId,
              stickerSeason: this.weaponForm.tiezhisaiji,
              stickerQuality: this.weaponForm.tiezhiquatity,
            },
          })
          .then((res) => {
            // console.log(res)
            if (res.code == 200) {
              this.tiezhiList = res.data.stickerList;
            }
          });
      }
    },
    //下架
    xiajia() {
      let productId = this.progressItem.productId + "";

      showConfirmDialog({
        title: "下架",
        message: "确定下架该饰品吗？",
      })
        .then(() => {
          //包装一层防抖
          this.debounceSubmit(() => {
            request
              .get(`/front/weapon/shelf/${productId}/0`, {})
              .then((res) => {
                if (res.code == 200) {
                  showToast("下架成功,已退回保证金");
                  this.showProgressPopup = false;
                  this.search();
                }
              });
          });
        })
        .catch(() => {
          showToast("取消操作");
        });
    },
    shangjia() {
      let productId = this.progressItem.productId + "";
      showConfirmDialog({
        title: "上架",
        message: "确定上架该饰品吗？",
      })
        .then(() => {
          request.get(`/front/weapon/shelf/${productId}/1`, {}).then((res) => {
            if (res.code == 200) {
              showToast("上架成功");
              this.showProgressPopup = false;
              this.search();
            } else {
              showToast(res.msg);
            }
          });
        })
        .catch(() => {
          showToast("取消操作");
        });
    },
    gengxin() {
      this.weaponForm = Object.assign({}, this.progressItem);
      this.selectTiezhiList = [];

      if (this.weaponForm.stickerUrls) {
        let arrImg = this.weaponForm.stickerUrls.split(",");
        for (let i = 0; i < arrImg.length; i++) {
          let flg = false;
          for (let u = 0; u < this.selectTiezhiList.length; u++) {
            if (this.selectTiezhiList[u].stickerSlot == arrImg[i]) {
              this.selectTiezhiList[u].num = this.selectTiezhiList[u].num + 1;
              flg = true;
              break;
            }
          }
          if (!flg) {
            let o = {
              stickerSlot: arrImg[i],
              // checked:true,
              num: 1,
            };
            this.selectTiezhiList.push(o);
            continue;
          }
        }
      }
      // console.log(this.weaponForm.stickerUrls)
      // this.selectTiezhiImg = this.weaponForm.stickerImageUrls
      this.showTopGengxin = true;
    },
    submitEdit() {
      let stickerUrls = [];
      if (this.selectTiezhiList.length > 0) {
        this.selectTiezhiList.forEach((item, index) => {
          for (let i = 0; i < item.num; i++) {
            stickerUrls.push(item.stickerSlot);
          }
        });
      }
      this.debounceSubmit(() => {
        request
          .post("/front/weapon/update", {
            productId: this.weaponForm.productId + "",
            categoryId: this.weaponForm.categoryId,
            quality: this.weaponForm.quality,
            template: this.weaponForm.template,
            isTemplate: this.weaponForm.isTemplate,
            price: this.weaponForm.price,
            isStack: this.weaponForm.isStack,
            stickerUrls: stickerUrls.length > 0 ? stickerUrls.join(",") : "",
          })
          .then((res) => {
            if (res.code == 200) {
              showToast("更新成功");
              this.pageNum = 1;
              this.getList();
              this.showTopGengxin = false;
              this.showProgressPopup = false;
            } else {
              showToast(res.msg);
            }
          });
      });
    },
    shanchu() {
      showConfirmDialog({
        title: "删除",
        message: "确定删除该饰品吗？",
      })
        .then(() => {
          this.debounceSubmit(() => {
            request
              .get("/front/weapon/delete", {
                params: {
                  productId: this.progressItem.productId + "",
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  showToast("删除成功");
                  this.showProgressPopup = false;
                  this.search();
                  // this.pageNum = 1
                  // this.getList()
                }
              });
          });
        })
        .catch(() => {
          showToast("取消操作");
        });
    },
    confirmTiezhiSelect() {
      console.log(this.selectTiezhiList);
      let max = 4;
      let num = 0;
      this.selectTiezhiList.forEach((item, index) => {
        num = num + item.num;
      });
      if (num > max) {
        showToast("最多只能选择4个");
        this.showTiezhi = true;
        return false;
      }
      this.showTiezhi = false;
    },
    changePinzhi(item) {
      this.weaponForm.tiezhiquatity = item;
      this.selectedPinzhiId = item;
      this.showTiezhipinzhi = false;
      if (this.weaponForm.tiezhisaiji && this.weaponForm.tiezhiquatity) {
        request
          .get("/front/weapon/sticker/list", {
            params: {
              categoryId: this.weaponForm.categoryId,
              stickerSeason: this.weaponForm.tiezhisaiji,
              stickerQuality: this.weaponForm.tiezhiquatity,
            },
          })
          .then((res) => {
            // console.log(res)
            if (res.code == 200) {
              this.tiezhiList = res.data.stickerList;
            }
          });
      }
    },
    onLoad() {
      console.log("进来了");
      if (this.finished) {
        return false;
      }
      // console.log(this.finished)
      // console.log(this.loading)
      // 如果已经加载完成或正在加载中，直接返回
      setTimeout(() => {
        this.pageNum++;
        this.getList();
      }, 500);
    },
    handleConfirm() {
      if (this.readAndAgree) {
        this.showConfirmDialog = true;
        if (this.free) {
          request.get("/front/profile/changeTip/saleTip").then((res) => {
            if (res.code == 200) {
              this.userinfo.saleTipFlag = 'N'
              this.$store.commit('user/UPDATE_USER_INFO', {
                saleTipFlag: 'N'
              })
            }
          });
        }
      }
    },
    beforeDialogClose(action) {
      if (action === "confirm") {
        if (!this.readAndAgree) {
          showToast("请先确认已知晓上述情况");
          return false;
        }
        return true;
      }
      return true;
    },
    changeNum(v) {
      if (!v.checked) {
        showToast("请先选择需要的贴纸");
        return false;
      }
      this.selectTiezhiList.forEach((it) => {
        if (it.stickerSlot == v.stickerSlot) {
          it.num = v.num;
          return false;
        }
      });
      // console.log(v)
    },
    changeTiezhi(item) {
      // const index = this.selectTiezhiList.indexOf(item.stickerSlot);
      let index = -1;
      let flg = false;
      for (let i = 0; i < this.selectTiezhiList.length; i++) {
        if (this.selectTiezhiList[i].stickerSlot == item.stickerSlot) {
          flg = true;
          index = i;
          break;
        }
      }
      // const index_imgurl = this.selectTiezhiImg.indexOf(item.stickerSlot);
      if (index == -1) {
        // 如果不在列表中，添加
        this.selectTiezhiList.push({
          stickerSlot: item.stickerSlot,
          num: item.num,
          checked: true,
        });
        item.checked = true;
      } else {
        // 如果已在列表中，移除
        this.selectTiezhiList.splice(index, 1);
        item.checked = false;
      }
      // if (index_imgurl === -1) {
      //   // 如果不在列表中，添加
      //   this.selectTiezhiImg.push(item.stickerSlot);
      // } else {
      //   // 如果已在列表中，移除
      //   this.selectTiezhiImg.splice(index_imgurl, 1);
      // }
      let stickerUrls = [];
      this.selectTiezhiImg = [];
      this.selectTiezhiList.forEach((d) => {
        stickerUrls.push(d.stickerSlot);
      });
      this.weaponForm.tiezhi = stickerUrls.join(",");
      // console.log(this.weaponForm.tiezhi)
      // console.log(this.selectTiezhiList)
    },
    viewProgress(item) {
      // console.log(item)
      this.progressItem = item;
      this.progressItem.tiezhiList = this.progressItem.stickerUrls
        ? this.progressItem.stickerUrls.split(",")
        : [];
      this.showProgressPopup = true;
    },
    async onMainActiveIndexChange(index) {
      this.weaponTreeData[index].text == "枪"
        ? (this.activeWeaponCategoryText = "枪")
        : (this.activeWeaponCategoryText = this.weaponTreeData[index].text);

      this.activeWeaponCategory = index;
      this.activeSecondCategory = -1;
      this.activeWeaponId = 0;

      const selectedCategory = this.weaponTreeData[index];
      // console.log(selectedCategory)
      if (selectedCategory && selectedCategory.children) {
        // 更新二级分类数据
        this.secondCategories = selectedCategory.children.map((item) => ({
          imageUrl: item.imageUrl,
          isStack: item.isStack,
          isTemplate: item.isTemplate,
          quality: item.quality,
          text: item.text,
          id: item.id,
          children: item.children || [],
        }));
      } else {
        this.secondCategories = [];
      }
      // console.log(this.secondCategories)
      this.thirdCategories = [];
    },

    onSecondCategoryClick(item, index) {
      this.activeSecondCategory = index;
      if (item.children && item.children.length > 0) {
        // 更新三级分类数据
        this.thirdCategories = item.children.map((child) => ({
          imageUrl: child.imageUrl,
          isStack: child.isStack,
          isTemplate: child.isTemplate,
          description: child.description,
          quality: child.quality,
          text: child.text,
          id: child.id,
          children: child.children || [],
        }));
      } else {
        this.activeWeaponId = item.id;
        this.weaponForm.categoryId = item.id;
        this.weaponForm.categoryName = item.text;
        this.weaponForm.imageUrl = item.imageUrl;
        this.weaponForm.isStack = item.isStack;
        this.weaponForm.isTemplate = item.isTemplate;
        this.weaponForm.description = item.description;
        this.weaponForm.quality = item.quality;
        this.thirdCategories = [];
      }
    },

    onWeaponItemClick(item) {
      // console.log(this.activeWeaponId2)
      this.activeWeaponId2 = item.id;
      if (item.children.length > 0) {
        this.showWeaponTreeSelect2 = true;
        this.fourCategories = item.children;
        return;
      } else {
        this.activeWeaponId = item.id;
        this.weaponForm.categoryId = item.id;
        this.weaponForm.categoryName = item.text;
        this.weaponForm.imageUrl = item.imageUrl;
        this.weaponForm.isStack = item.isStack;
        this.weaponForm.isTemplate = item.isTemplate;
        this.weaponForm.description = item.description;
        this.weaponForm.quality = item.quality;
      }
    },
    onWeaponItemClick2(item, index) {
      // console.log(item.id)
      this.activeWeaponId = item.id;
      this.activeWeaponIndex4 = index;
      // this.activeWeaponId2 = item.id
      this.weaponForm.categoryId = item.id;
      this.weaponForm.categoryName = item.text;
      this.weaponForm.imageUrl = item.imageUrl;
      this.weaponForm.isStack = item.isStack;
      this.weaponForm.isTemplate = item.isTemplate;
      this.weaponForm.description = item.description;
      this.weaponForm.quality = item.quality;
      this.showWeaponTreeSelect2 = false;
    },

    // 取消饰品类型选择
    cancelWeaponSelect() {
      this.showWeaponTreeSelect = false;
      // 如果之前没有选择过，则重置选择状态
      if (!this.weaponForm.category) {
        this.activeWeaponCategory = 0;
        this.activeWeaponId = "";
        this.selectedWeapon = null;
      }
    },

    // 确认饰品类型选择
    confirmWeaponSelect() {
      if (!this.activeWeaponId) {
        showToast("请选择具体饰品类型");
        return;
      }
      this.showWeaponTreeSelect = false;
    },

    // 表单验证
    validateForm() {
      if (!this.weaponForm.categoryName) {
        showToast("请输入饰品名称");
        return false;
      }

      if (!this.weaponForm.price || this.weaponForm.price <= 0) {
        showToast("请输入有效价格");
        return false;
      }
      return true;
    },
    getStatusType(status) {
      const typeMap = {
        isShelves: "primary",
        dealing: "success",
        over: "danger",
      };
      return typeMap[status] || "default";
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        isShelves: "已上架",
        dealing: "交易中",
        over: "已交易",
      };
      return textMap[status] || "未知状态";
    },

    // 状态切换
    onStatusChange(name) {
      console.log(name);
      this.currentStatus = name;
      this.search();
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    search() {
      this.finished = false;
      this.tableData = [];
      this.pageNum = 1;
      this.getList();
    },
    reset() {
      this.finished = false;
      this.filterForm = {};
      this.pageNum = 1;
      this.getList();
    },
    doStock() {
      this.showTop = true;
      this.weaponForm = {
        tiezhi: "",
      };
      this.tiezhiList = [];
      this.selectTiezhiImg = [];
      this.selectTiezhiList = [];
    },
    // 滚动事件处理
    onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;

      // 当滚动到距离底部50px时触发加载
      if (
        scrollTop + clientHeight >= scrollHeight - 50 &&
        !this.loading &&
        !this.finished
      ) {
        this.loadMore();
      }
    },

    // 饰品类型选择确认
    onCategoryConfirm({ selectedOptions }) {
      this.weaponForm.category = selectedOptions[0].text;
      this.showCategoryPicker = false;
    },

    // 稀有度选择确认
    onRarityConfirm({ selectedOptions }) {
      this.weaponForm.rarity = selectedOptions[0].text;
      this.showRarityPicker = false;
    },

    // 磨损程度选择确认
    onWearConfirm({ selectedOptions }) {
      this.weaponForm.wear = selectedOptions[0].text;
      this.showWearPicker = false;
    },

    // 提交饰品信息
    submitWeapon() {
      if (!this.validateForm()) {
        return;
      }
      request.post("/front/weapon/getEarnestMoneyPercent").then((res) => {
        if (res.code == 200) {
          this.earnestMoneyPercent = res.data.earnestMoneyPercent;
          this.transactionFeePercent = res.data.transactionFeePercent;
          if (this.userinfo.saleTipFlag == 'Y') {
            this.showConfirmMsg = true;
          } else {
            this.showConfirmDialog = true;
          }
        }
      });
    },
    openStickerPicker() {
      this.checkedStickers = [...this.weaponForm.stickers];
      this.showStickerPicker = true;
    },
    toggleSticker(sticker) {
      const idx = this.checkedStickers.indexOf(sticker);
      if (idx > -1) {
        this.checkedStickers.splice(idx, 1);
      } else {
        this.checkedStickers.push(sticker);
      }
    },
  },
};
</script>

<style scoped>
.stock-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
}

.form-container {
  padding: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 12px;
  padding-left: 4px;
}

.upload-section {
  margin-bottom: 20px;
}

.upload-tip {
  font-size: 12px;
  color: #969799;
  margin-top: 8px;
  padding-left: 4px;
}

.info-section {
  margin-bottom: 20px;
}

.desc-section {
  margin-bottom: 20px;
}

.trade-section {
  margin-bottom: 30px;
}

.submit-section {
  padding: 0 4px;
  margin-bottom: 20px;
}

.price-unit {
  color: #969799;
  font-size: 14px;
}

.preview-cover {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 12px;
  text-align: center;
  padding: 4px;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .form-container {
    padding: 12px;
  }

  .section-title {
    font-size: 15px;
  }
}

.back-content {
  display: flex;
  flex-direction: column;
  /* flex-wrap: wrap; 删除这行 */
  padding: 10px;
  flex: 1;
  /* 占用剩余空间 */
  min-height: 0;
  /* 允许收缩 */
}

.empty-state {
  background: white;
  padding: 40px 20px;
  border-radius: 8px;
  text-align: center;
}

.recycle-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 120px;
}

.recycle-card:active {
  transform: scale(0.98);
  /* background-color: #f8f9fa; */
}

.card-content {
  display: flex;
  align-items: center;
  position: relative;
}

.weapon-image {
  margin-right: 12px;
  border-radius: 6px;
  overflow: hidden;
}

.recycle-info {
  flex: 1;
  min-width: 0;
}

.weapon-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-info,
.date-info {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 14px;
}

.label {
  color: #969799;
  margin-right: 4px;
}

.price {
  color: #ee0a24;
  font-weight: 600;
}

.date {
  color: #323233;
}

.status-badge {
  margin-top: 8px;
}

.arrow-icon {
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
}

.success-info p {
  margin: 8px 0;
  color: #323233;
}

.action-buttons {
  padding: 16px;
  background: white;
  display: flex;
  gap: 12px;
}

.action-buttons .van-button {
  flex: 1;
}

.card-list {
  overflow-y: scroll;
  flex: 1;
  overflow-y: auto;
  /* 改为 auto */
  /* 自定义滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

.card-list::-webkit-scrollbar {
  width: 6px;
}

.card-list::-webkit-scrollbar-track {
  background: transparent;
}

.card-list::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.card-list::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}

/* 加载更多样式 */
.loading-more {
  padding: 20px;
  text-align: center;
  color: #969799;
}

.no-more {
  padding: 20px 0;
  text-align: center;
}

/* 回收表单样式 */
.recycle-form {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebedf0;
}

.form-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.form-actions {
  padding: 20px 0;
  margin-top: auto;
  justify-content: space-around;
}

/* 上传组件样式优化 */
.van-uploader {
  margin-top: 8px;
}

/* 树形选择器样式 */
.tree-select-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tree-select-header {
  flex-shrink: 0;
}

.tree-select-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tree-select-header {
  flex-shrink: 0;
}

.tree-select-content {
  flex: 1;
  overflow-y: auto;
}

/* 饰品预览区域样式 */
.weapon-preview {
  padding: 15px;
  background-color: #f7f8fa;
  border-top: 1px solid #ebedf0;
}

.preview-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #323233;
}

.preview-image {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 品质选择器样式 */
.quality-picker-container {
  padding-bottom: 20px;
}

.quality-options {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quality-option {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.quality-selected {
  background-color: #f2f3f5;
  border-left: 3px solid #1989fa;
}

.quality-color {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin-right: 12px;
  border: 1px solid #dcdfe6;
}

.quality-name {
  font-size: 14px;
  color: #323233;
}

/* style scoped 里补充 */
.sticker-picker-container {
  padding-bottom: 20px;
}

.sticker-picker-header {
  flex-shrink: 0;
}

.sticker-options {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.sticker-option {
  position: relative;
  border: 2px solid #eee;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s, background 0.2s;
}

.sticker-selected {
  border: 2px solid #1989fa;
  background: #f2f3f5;
}

.template-wrapper {
  position: absolute;
  bottom: 0px;
  display: inline-flex;
  align-items: center;
}

.template {
  position: absolute;
  left: 42%;
  top: 70%;
  transform: translate(-50%, -50%);
  color: #eee;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

.sticker-image {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  object-fit: cover;
  border: 1px solid #e8e8e8;
  background: #f5f5f5;
}

.search-bar {
  background: white;
  padding: 10px;
  display: flex;
  align-items: center;
}

.search-icon {
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-form {
  padding: 18px 10px 10px 10px;
}

.tree-select-content {

  .second-category,
  .third-category {
    padding: 12px 0;
  }

  .second-item,
  .third-item {
    padding: 10px 16px;
    font-size: 14px;
    position: relative;
    cursor: pointer;
  }

  .second-item.active,
  .third-item.active {
    color: #1989fa;
    background-color: #f7f8fa;
  }

  .second-item::after {
    position: absolute;
    right: 16px;
    /* content: '>'; */
  }
}

.active2 {
  color: #1989fa !important;
  background-color: #f7f8fa !important;
}

.recycle-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 70px;
  right: 10px;
  /* background: linear-gradient(45deg, #1989fa, #4bb0ff); */
  background-color: #ffffff;
  border: none;
  z-index: 100;
  width: 70px;
  height: 80px;
}

.recycle-button:active {
  transform: scale(0.95);
  box-shadow: 0 1px 3px rgba(25, 137, 250, 0.3);
}
</style>
